import React from 'react';
import { Suggestion } from '@components/common/Suggestion';
import { StepProgressBar } from '@fourthwall/components/dist/common/StepProgressBar';
import { useRecommendationsDismiss } from '@modules/Dashboard/Home/modules/recommendations/useRecommendationsDismiss';
import * as S from './styled';
export const CreatorChallengeFailureContainer = (props) => {
    const { recommendationsDismiss } = useRecommendationsDismiss();
    const handleDismiss = () => {
        recommendationsDismiss.creatorChallenge.dismiss();
        props.onDismiss();
    };
    return (React.createElement(S.CurrentChallengeProgressContainer, null,
        React.createElement(Suggestion, { title: "Your challenge has ended unsuccessfully.", onDismiss: handleDismiss, content: React.createElement("div", null,
                React.createElement("p", null,
                    "Unfortunately you didn't reach your goal of selling $",
                    props.expected,
                    " products within 60 days."),
                React.createElement(S.ProgressBarContainer, null,
                    React.createElement(StepProgressBar, { step: props.current, totalSteps: props.expected, appearance: "warning" })),
                React.createElement(S.ProgressSubtitles, null,
                    React.createElement(S.Counter, null,
                        props.current,
                        " out of ",
                        props.expected,
                        " products sold"),
                    React.createElement("span", null, "Challenge ended"))) })));
};
